import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { BookOpenIcon, ClockIcon, MoonIcon, TableIcon, NotebookPenIcon, VolumeXIcon, CheckCircle2Icon, XCircleIcon, SearchIcon, RefreshCwIcon, LayersIcon } from 'lucide-react';
export function OfferSection() {
  return <section className="relative bg-night-800 py-20 md:py-28 overflow-hidden" data-id="element-145">
      {/* Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[400px] rounded-full" style={{
      background: 'radial-gradient(ellipse, rgba(245,197,66,0.06) 0%, transparent 70%)'
    }} aria-hidden="true" data-id="element-146" />

      <div className="relative z-10 max-w-4xl mx-auto px-5 sm:px-8" data-id="element-147">
        {/* What You Get */}
        <AnimatedSection data-id="element-148">
          <div className="text-center mb-14" data-id="element-149">
            <h2 className="font-playfair text-3xl sm:text-4xl md:text-5xl font-bold text-cream-100 mb-4" data-id="element-150">
              Todo lo que recibes
            </h2>
            <p className="font-dm-sans text-lg text-cream-200/60" data-id="element-151">
              Acceso inmediato a herramientas probadas
            </p>
          </div>
        </AnimatedSection>

        <div className="space-y-4 mb-20" data-id="element-152">
          <AnimatedSection delay={0} data-id="element-153">
            <div className="flex items-start gap-4 bg-night-700/50 border border-night-600/30 rounded-xl p-5 sm:p-6" data-id="element-154">
              <div className="w-10 h-10 rounded-lg bg-gold-400/10 flex items-center justify-center flex-shrink-0" data-id="element-155">
                <BookOpenIcon className="w-5 h-5 text-gold-400" data-id="element-156" />
              </div>
              <div data-id="element-157">
                <h3 className="font-dm-sans text-base sm:text-lg font-semibold text-cream-100 mb-1" data-id="element-158">
                  El eBook completo: Método Noches en Paz
                </h3>
                <p className="font-dm-sans text-sm text-cream-200/50" data-id="element-159">
                  Guía paso a paso con todo el sistema
                </p>
              </div>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={60} data-id="element-160">
            <div className="flex items-start gap-4 bg-night-700/50 border border-night-600/30 rounded-xl p-5 sm:p-6" data-id="element-161">
              <div className="w-10 h-10 rounded-lg bg-gold-400/10 flex items-center justify-center flex-shrink-0" data-id="element-162">
                <ClockIcon className="w-5 h-5 text-gold-400" data-id="element-163" />
              </div>
              <div data-id="element-164">
                <h3 className="font-dm-sans text-base sm:text-lg font-semibold text-cream-100 mb-1" data-id="element-165">
                  El Protocolo de la Ventana de Oro
                </h3>
                <p className="font-dm-sans text-sm text-cream-200/50" data-id="element-166">
                  Detecta el momento exacto del sueño de tu bebé
                </p>
              </div>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={120} data-id="element-167">
            <div className="flex items-start gap-4 bg-night-700/50 border border-night-600/30 rounded-xl p-5 sm:p-6" data-id="element-168">
              <div className="w-10 h-10 rounded-lg bg-gold-400/10 flex items-center justify-center flex-shrink-0" data-id="element-169">
                <MoonIcon className="w-5 h-5 text-gold-400" data-id="element-170" />
              </div>
              <div data-id="element-171">
                <h3 className="font-dm-sans text-base sm:text-lg font-semibold text-cream-100 mb-1" data-id="element-172">
                  La Técnica de la Penumbra
                </h3>
                <p className="font-dm-sans text-sm text-cream-200/50" data-id="element-173">
                  Rutina de 3 pasos para bajar la ansiedad del bebé
                </p>
              </div>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={180} data-id="element-174">
            <div className="flex items-start gap-4 bg-night-700/50 border border-night-600/30 rounded-xl p-5 sm:p-6" data-id="element-175">
              <div className="w-10 h-10 rounded-lg bg-gold-400/10 flex items-center justify-center flex-shrink-0" data-id="element-176">
                <TableIcon className="w-5 h-5 text-gold-400" data-id="element-177" />
              </div>
              <div data-id="element-178">
                <h3 className="font-dm-sans text-base sm:text-lg font-semibold text-cream-100 mb-1" data-id="element-179">
                  Tabla Maestra de Ventanas de Despertar
                </h3>
                <p className="font-dm-sans text-sm text-cream-200/50" data-id="element-180">
                  Según la edad exacta de tu hijo
                </p>
              </div>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={240} data-id="element-181">
            <div className="flex items-start gap-4 bg-night-700/50 border border-night-600/30 rounded-xl p-5 sm:p-6" data-id="element-182">
              <div className="w-10 h-10 rounded-lg bg-gold-400/10 flex items-center justify-center flex-shrink-0" data-id="element-183">
                <NotebookPenIcon className="w-5 h-5 text-gold-400" data-id="element-184" />
              </div>
              <div data-id="element-185">
                <h3 className="font-dm-sans text-base sm:text-lg font-semibold text-cream-100 mb-1" data-id="element-186">
                  Bitácora de Sueño "Noche Serena"
                </h3>
                <p className="font-dm-sans text-sm text-cream-200/50" data-id="element-187">
                  Mide tu progreso diario
                </p>
              </div>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={300} data-id="element-188">
            <div className="flex items-start gap-4 bg-night-700/50 border border-night-600/30 rounded-xl p-5 sm:p-6" data-id="element-189">
              <div className="w-10 h-10 rounded-lg bg-gold-400/10 flex items-center justify-center flex-shrink-0" data-id="element-190">
                <VolumeXIcon className="w-5 h-5 text-gold-400" data-id="element-191" />
              </div>
              <div data-id="element-192">
                <h3 className="font-dm-sans text-base sm:text-lg font-semibold text-cream-100 mb-1" data-id="element-193">
                  Auditoría de la "Cueva de Sueño"
                </h3>
                <p className="font-dm-sans text-sm text-cream-200/50" data-id="element-194">
                  Elimina ruidos y luces enemigas del cuarto
                </p>
              </div>
            </div>
          </AnimatedSection>
        </div>

        {/* Who This Is For / Not For */}
        <div className="grid md:grid-cols-2 gap-6 mb-20" data-id="element-195">
          <AnimatedSection data-id="element-196">
            <div className="bg-night-700/40 border border-green-500/15 rounded-2xl p-7 h-full" data-id="element-197">
              <h3 className="font-playfair text-2xl font-bold text-cream-100 mb-6" data-id="element-198">
                Esto es para ti si…
              </h3>
              <ul className="space-y-4" data-id="element-199">
                <li className="flex items-start gap-3" data-id="element-200">
                  <CheckCircle2Icon className="w-5 h-5 text-green-400/80 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-201" />
                  <span className="font-dm-sans text-sm text-cream-200/70 leading-relaxed" data-id="element-202">
                    Eres una madre agotada que siente que ya no puede más con
                    los despertares constantes.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-203">
                  <CheckCircle2Icon className="w-5 h-5 text-green-400/80 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-204" />
                  <span className="font-dm-sans text-sm text-cream-200/70 leading-relaxed" data-id="element-205">
                    Eres madre joven (desde los 18 años) y buscas una guía clara
                    y sin juicios.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-206">
                  <CheckCircle2Icon className="w-5 h-5 text-green-400/80 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-207" />
                  <span className="font-dm-sans text-sm text-cream-200/70 leading-relaxed" data-id="element-208">
                    Tu familia no quiere dejar al bebé llorando solo en una
                    habitación.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-209">
                  <CheckCircle2Icon className="w-5 h-5 text-green-400/80 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-210" />
                  <span className="font-dm-sans text-sm text-cream-200/70 leading-relaxed" data-id="element-211">
                    Trabajas y necesitas recuperar tu rendimiento y claridad
                    mental.
                  </span>
                </li>
              </ul>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={100} data-id="element-212">
            <div className="bg-night-700/40 border border-red-400/10 rounded-2xl p-7 h-full" data-id="element-213">
              <h3 className="font-playfair text-2xl font-bold text-cream-100 mb-6" data-id="element-214">
                Esto NO es para ti si…
              </h3>
              <ul className="space-y-4" data-id="element-215">
                <li className="flex items-start gap-3" data-id="element-216">
                  <XCircleIcon className="w-5 h-5 text-red-400/60 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-217" />
                  <span className="font-dm-sans text-sm text-cream-200/70 leading-relaxed" data-id="element-218">
                    Buscas una solución mágica de una sola noche sin aplicar
                    cambios.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-219">
                  <XCircleIcon className="w-5 h-5 text-red-400/60 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-220" />
                  <span className="font-dm-sans text-sm text-cream-200/70 leading-relaxed" data-id="element-221">
                    Prefieres métodos de entrenamiento rígidos o de "extinción
                    del llanto".
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-222">
                  <XCircleIcon className="w-5 h-5 text-red-400/60 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-223" />
                  <span className="font-dm-sans text-sm text-cream-200/70 leading-relaxed" data-id="element-224">
                    No estás dispuesta a ajustar la rutina de luces y ruidos en
                    casa.
                  </span>
                </li>
              </ul>
            </div>
          </AnimatedSection>
        </div>

        {/* How It Works */}
        <AnimatedSection data-id="element-225">
          <h2 className="font-playfair text-3xl sm:text-4xl font-bold text-cream-100 mb-12 text-center" data-id="element-226">
            Cómo funciona
          </h2>
        </AnimatedSection>

        <div className="grid sm:grid-cols-3 gap-6" data-id="element-227">
          <AnimatedSection delay={0} data-id="element-228">
            <div className="text-center bg-night-700/30 border border-night-600/30 rounded-2xl p-7" data-id="element-229">
              <div className="w-14 h-14 rounded-full bg-gold-400/10 border border-gold-400/20 flex items-center justify-center mx-auto mb-5" data-id="element-230">
                <SearchIcon className="w-6 h-6 text-gold-400" data-id="element-231" />
              </div>
              <span className="inline-block font-dm-sans text-xs font-bold text-gold-400 tracking-widest uppercase mb-3" data-id="element-232">
                Paso 1
              </span>
              <h3 className="font-playfair text-xl font-semibold text-cream-100 mb-3" data-id="element-233">
                Identifica
              </h3>
              <p className="font-dm-sans text-sm text-cream-200/60 leading-relaxed" data-id="element-234">
                Detectas la Ventana de Oro de tu bebé usando nuestra guía
                visual.
              </p>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={100} data-id="element-235">
            <div className="text-center bg-night-700/30 border border-night-600/30 rounded-2xl p-7" data-id="element-236">
              <div className="w-14 h-14 rounded-full bg-gold-400/10 border border-gold-400/20 flex items-center justify-center mx-auto mb-5" data-id="element-237">
                <RefreshCwIcon className="w-6 h-6 text-gold-400" data-id="element-238" />
              </div>
              <span className="inline-block font-dm-sans text-xs font-bold text-gold-400 tracking-widest uppercase mb-3" data-id="element-239">
                Paso 2
              </span>
              <h3 className="font-playfair text-xl font-semibold text-cream-100 mb-3" data-id="element-240">
                Sincroniza
              </h3>
              <p className="font-dm-sans text-sm text-cream-200/60 leading-relaxed" data-id="element-241">
                Aplicas la Rutina de la Penumbra para preparar su sistema
                biológico.
              </p>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={200} data-id="element-242">
            <div className="text-center bg-night-700/30 border border-night-600/30 rounded-2xl p-7" data-id="element-243">
              <div className="w-14 h-14 rounded-full bg-gold-400/10 border border-gold-400/20 flex items-center justify-center mx-auto mb-5" data-id="element-244">
                <LayersIcon className="w-6 h-6 text-gold-400" data-id="element-245" />
              </div>
              <span className="inline-block font-dm-sans text-xs font-bold text-gold-400 tracking-widest uppercase mb-3" data-id="element-246">
                Paso 3
              </span>
              <h3 className="font-playfair text-xl font-semibold text-cream-100 mb-3" data-id="element-247">
                Consolida
              </h3>
              <p className="font-dm-sans text-sm text-cream-200/60 leading-relaxed" data-id="element-248">
                Sigues el plan de 7 días para conectar los ciclos de sueño
                nocturno.
              </p>
            </div>
          </AnimatedSection>
        </div>

        {/* Proof */}
        <AnimatedSection data-id="element-249">
          <div className="mt-16 bg-gradient-to-r from-gold-400/10 via-gold-400/5 to-gold-400/10 border border-gold-400/15 rounded-2xl p-8 md:p-10 text-center" data-id="element-250">
            <h3 className="font-playfair text-2xl sm:text-3xl font-bold text-cream-100 mb-4" data-id="element-251">
              Lo que cambia en 7 días
            </h3>
            <p className="font-dm-sans text-base sm:text-lg text-cream-200/80 leading-relaxed max-w-2xl mx-auto" data-id="element-252">
              Pasarás de{' '}
              <strong className="text-red-400/80" data-id="element-253">
                5-6 despertares angustiantes
              </strong>{' '}
              a un primer tramo de sueño sólido de{' '}
              <strong className="text-gold-400" data-id="element-254">6 a 8 horas</strong>,
              permitiéndote despertar con energía y sin la presión en el pecho
              por el agotamiento.
            </p>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}